<template>
    <div>
        <div class="shadow-lg rounded-lg flex flex-col border-t-4 border-blue-dark bg-white">

            <div class="p-4">
                <p class="">Export your sheet/table view into Excel or CSV format</p>

                <form action="/excel" method="post" class="mt-2">
                    <input type="hidden" name="_token" :value="csrf">
                    <input type="hidden" name="csv" :value="csv">
                    <input type="hidden" name="file" :value="id">
                    <button type="submit" class="rounded inline-block px-4 py-2 bg-blue-dark text-white">
                        <i class="fa fa-save"></i>
                        Excel
                    </button>
                </form>

                <p class="mt-2">
                    <a class="rounded inline-block px-4 py-2 bg-blue-dark text-white" @click="getCSV()">
                        <i class="fa fa-save"></i>
                        CSV
                    </a>
                </p>

            </div>

        </div>
    </div>
</template>

<script>
    import http from "../http";

    export default {

        computed: {
            id() {
                return this.$store.state.id;
            },
            csv() {
                return this.$store.getters.csv;
            },
            csrf() {
                return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
            },
        },

        methods: {
            getCSV() {
                const fileName = this.id + '.csv';

                const json = this.csv;
                //IE11 support
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    let blob = new Blob([json], {type: "text/csv"});
                    window.navigator.msSaveOrOpenBlob(blob, fileName);
                } else {// other browsers
                    let file = new File([json], fileName, {type: "text/csv"});
                    let exportUrl = URL.createObjectURL(file);
                    window.location.assign(exportUrl);
                    URL.revokeObjectURL(exportUrl);
                }
            },
        },

    }
</script>
